<template>
 <!-- Sidebar -->
 <aside class="sidebar sidebar-icons-right sidebar-icons-boxed sidebar-expand-lg">
    <div class="sidebar-profile">
          <div class="profile-info">
            <h4>Fitila Admin</h4>
          </div>
    </div>
    <bounce class="my-200" v-if="loading"></bounce>
    <nav class="scroll sidebar-navigation" v-else>
        <ul class="menu menu-lg menu-bordery">

          <li class="menu-item">
            <router-link tag="a" to="/admin/dashboard" class="menu-link">
               <span class="icon ion-ios-home"></span>
              <span class="title">
                <span>Dashboard</span>
              </span> 
            </router-link>
          </li>
          <li class="menu-item">
                <a class="menu-link" href="#">
                  <span class="icon ion-android-contacts"></span>
                    <span class="title">
                        Users
                    </span>
                    <span class="arrow"></span>
                </a>
                <ul class="menu-submenu">
                    <router-link tag="li" to="/admin/team-members" class="menu-item" v-if="is_superAdmin">
                        <a class="menu-link" href="#">
                            <span class="dot"></span>
                            <span class="title">Admin Members</span>
                        </a>
                    </router-link>
                    <router-link tag="li" to="/admin/volunteers" class="menu-item">
                        <a class="menu-link" href="#">
                            <span class="dot"></span>
                            <span class="title">Volunteers</span>
                        </a>
                    </router-link>
                    <router-link tag="li" to="/admin/users" class="menu-item">
                        <a class="menu-link" href="#">
                            <span class="dot"></span>
                            <span class="title">Listeners and Members</span>
                        </a>
                    </router-link>
                </ul>
           </li>
          <li class="menu-item">
            <router-link tag="a" to="/admin/trainings" class="menu-link">
               <span class="icon ion-ios-paper-outline"></span>
              <span class="title">Listener Trainings</span>
            </router-link>
          </li>
          <li class="menu-item">
            <router-link tag="a" to="/admin/clubs" class="menu-link">
              <span class="icon ion-ios-color-filter-outline"></span>
              <span class="title">Campus Clubs</span>
            </router-link>
          </li>
          <li class="menu-item">
            <router-link tag="a" to="/admin/events" class="menu-link">
              <span class="icon ion-ios-calendar-outline"></span>
              <span class="title">Events</span>
            </router-link>
          </li>
          <li class="menu-item">
            <router-link tag="a" to="/admin/extras" class="menu-link">
              <span class="icon ion-folder"></span>
              <span class="title">Extras </span>
            </router-link>
          </li>
          <li class="menu-item">
            <a class="menu-link" href="#" @click="logOut">
              <span class="icon ion-log-out"></span>
              <span class="title">Log Out</span>
              <circle-spin v-if="log_load" class="float-right"></circle-spin>
            </a>
          </li>
        </ul>
      </nav>

    </aside>
    <!-- END Sidebar -->
</template>

<script>
import axios from 'axios'
import allMixins from '../../mixins.js'

export default {
  mixins: [allMixins],
  data() {
    return {
      loading: true,
      log_load: false,
      is_superAdmin: true
    }
  },
  methods: {
    logOut() {
      this.log_load = true
      axios.post('/users/signout')
     .then(res => {
       this.log_load = false
        localStorage.clear()
        this.$notify({
          group: 'response',
          type: 'success',
          text: 'Successfully Logged Out',
          duration: 1500,
        })
        setTimeout(() => {
            this.$router.push('/')
          }, 2000)       
      })
      .catch(err => {
          this.log_load = false
          this.$notify({
          group: 'response',
          type: 'error',
          text:  `${err.response.data.message}`,
          duration: 2500,
      });
    }) 
    }
  },
  mounted() {
    this.loading = true
    let details = this.$jwt.decode(this.retrieveToken(window.btoa('userToken')), "inGXVHWPU9BB5q2oix1r-zaA")
    if (details.userRoles.includes("admin_member")) {
      this.is_superAdmin = false
      this.loading = false
    }
    else this.loading = false
  }
}
</script>